import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import ContactForm from './ContactForm'

const ContactFormInSection: React.FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.box}>
      <ContactForm inSection={true} />
    </Box>
  )
}

const useStyles = makeStyles((theme) =>
  createStyles({
    box: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,
      padding: '2rem',
    },
  })
)

export default ContactFormInSection
